import _ from 'lodash'
import { noop, omit } from 'lodash/fp'
import { memo, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Flex } from 'rebass'

import { getCurrentApp } from 'e-submission/apps/selectors'
import * as _FormComponent from 'e-submission/components/Form'

import addFormGroup from './addFormGroup'
import addLocalState from './addLocalState'
import addValidation from './addValidation'
import connectForm from './connectForm'
import { useHistory } from 'react-router-dom'

const AllFormComponents = _.mapValues(_FormComponent, (Component, displayName) => {
  let Wrapped = addFormGroup(Component)
  Wrapped = addValidation(Wrapped)
  Wrapped = addLocalState(Wrapped)
  Wrapped = connectForm(Wrapped)
  Wrapped = memo(Wrapped)
  Wrapped.displayName = displayName + 'Component'
  return Wrapped
})

const FormManager = ({
  elements,
  setValue = noop,
  unsetValue = noop,
  removeValue = noop,
  showDialog = noop,
  hideDialog = noop,
  styleOptions,
  toggleModal,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const state = useSelector((state) => state)
  const app = getCurrentApp(state)

  const INTERNAL_PROPS = ['dispatch', 'allow', 'validate', 'match', 'history', 'location', 'staticContext']
  const renderedChildren = useMemo(() => {
    if (!elements) return null

    return elements.map(({ c: component, p: elementProps, ...otherProps }, index) => {
      const Component = AllFormComponents[component]
      if (_.isNil(Component)) {
        console.log(`component : ${component}`)
        return <label key={index}>!! Component {component} not found.</label>
      }

      const allProps = {
        ...elementProps,
        ...otherProps,
        component,
        styleOptions,
        setValue,
        unsetValue,
        removeValue,
        showDialog,
        hideDialog,
      }

      const { mergeProps = noop, ...restProps } = allProps
      const mergedProps = omit(INTERNAL_PROPS)({ ...restProps, ...mergeProps(restProps) })
      const mergeState = mergedProps.mergeState ? mergedProps.mergeState(state, app, { dispatch }) : {}
      const hasMergedValue = _.has(mergeState, 'value')
      const resolvedValue = hasMergedValue ? mergeState.value : mergedProps.value
      const resolvedActualValue = hasMergedValue ? mergeState.value : mergedProps.actualValue
      return (
        <Component
          key={index}
          {...mergedProps}
          {...mergeState}
          value={resolvedValue}
          actualValue={resolvedActualValue}
          dispatch={dispatch}
          history={history}
          EtoggleModal={toggleModal}
        />
      )
    })
  }, [
    elements,
    setValue,
    unsetValue,
    removeValue,
    showDialog,
    hideDialog,
    styleOptions,
    state,
    app,
    dispatch,
    history,
    toggleModal,
  ])

  return (
    <Flex wrap justify="space-between">
      {renderedChildren}
    </Flex>
  )
}

export default FormManager
